(function($){
    if($('.e-coupon-anchor-description').length > 0){
        $('.e-coupon-anchor-description').html('Jeśli posiadasz kod kuponu, wpisz go w poniższym polu.');
    }
})(jQuery)